// extracted by mini-css-extract-plugin
module.exports = {"typingAvatar":"widget-demo--typingAvatar--29Ojd","avatar":"widget-demo--avatar--3g98r"};